var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationMultiple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120-80q-33 0-56.5-23.5T40-160v-480q0-17 11.5-28.5T80-680q17 0 28.5 11.5T120-640v480h560q17 0 28.5 11.5T720-120q0 17-11.5 28.5T680-80H120Zm720-240v-258L600-438q-19 11-40 11t-40-11L280-578v258h560Zm-560 80q-33 0-56.5-23.5T200-320v-340q0-21 9.5-40t28.5-30l261-154q14-8 30.5-4t24.5 18q9 14 4.5 31T540-814L288-666l272 160 270-160q15-9 30.5-8.5T890-666q14 8 22 21.5t8 30.5v294q0 33-23.5 56.5T840-240H280Zm280-432 114-114q11-11 28-11t28 11q11 11 11 28t-11 28L588-588q-12 12-28 12t-28-12l-56-56q-11-11-11-28t11-28q11-11 28-11t28 11l28 28ZM280-320h560-560Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationMultiple);
export default __webpack_public_path__ + "static/media/notification_multiple.a5af50e162a5421f8bb62483bdada030.svg";
export { ForwardRef as ReactComponent };